import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TextModule } from '../text/text.module';
import { DataDisplayComponent } from './data-display.component'

@NgModule({
  declarations: [DataDisplayComponent],
  imports: [CommonModule, TextModule],
  exports: [DataDisplayComponent],
})
export class DataDisplayModule {}